import React, { useState } from 'react';
import { faPencilAlt, faTruck } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'reactstrap';


// Components
import ModalidadeColeta from './components/ModalidadeColeta';
import Transporte_Destinacao from './components/Transporte_Destinacao';
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import Stepper from '../../../components/Stepper/Stepper';

//Context
import { useAuth } from 'context/auth';

//Helpers
import { showMessage } from 'helpers/message';


function initialStateRedestinacao(tbDestinos_Id) {
    return {
        tbDestinos_Id: tbDestinos_Id,
        tbTransportadores_Id: "",
        tbVeiculos_Id: "",
        status: "Pendente",
        redestinacaoTipoColetas: [],
        redestinacaoDestino: {
            tbDestinos_Id: "",
        }
    }
}
function NovoEnviarResiduo({ redestinacaoItem = null, btnVoltar }) {
    const { session } = useAuth();

    //Estado de controle para os passos do cadastro
    const [activeStep, setActiveStep] = useState(1);

    //Estado de controle dos campos do redestinação
    const [redestinacao, setRedestinacao] = useState(redestinacaoItem ? redestinacaoItem : initialStateRedestinacao(session?.acesso.acesso_id));

    //Função de validação dos campos de identificação do gerador
    function validarDadosModalidadeColeta() {
        if (redestinacao?.redestinacaoTipoColetas?.length == 0 || redestinacao?.redestinacaoTipoColetas?.filter(x => x.pesoDestinado != "" && x.pesoDestinado != "0,00").length == 0) {
            showMessage("Aviso", "Informe o peso a ser destinado.", "info", null);
            return ["Informe o peso a ser destinado."];
        }
        return [];
    }

    //Função para pegar os passos do cadastro/edição de geradores
    const steps = [
        { text: "Modalidade de Coleta", icon: faPencilAlt, validateStep: validarDadosModalidadeColeta },
        { text: "Transporte e Destinação", icon: faTruck },
    ];

    function getStep() {
        switch (activeStep) {
            case 1:
                return <ModalidadeColeta
                    redestinacaoItem={redestinacao}
                    setRedestinacao={setRedestinacao}
                />
            case 2:
                return <Transporte_Destinacao
                    redestinacaoItem={redestinacao}
                    setRedestinacao={setRedestinacao}
                    setActiveStep={setActiveStep}
                    btnVoltar={btnVoltar}
                />
        }
    }

    return <>
        <MainCard btnVoltar={btnVoltar}>
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Stepper
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                steps={steps}
                hideButton={activeStep == 2}
            >
                {getStep()}
            </Stepper>

        </MainCard>
    </>;
}

export default NovoEnviarResiduo;